<template>
  <div class="bg">
    <div class="banner"></div>
    <div class="introduce">
      <p class="title">玩咖资源</p>
      <p class="title-en">玩咖拥有主流媒体资源</p>
      <i class="nav"></i>
      <div class="appShopBox">
        <div class="shop">
          <div class="titleBox">
            <span class="title-left"></span>
            <span class="title">应用商店</span>
          </div>
          <img class="shop-img" src="../../assets/img/service/1.png" alt />
        </div>
        <div class="shop">
          <div class="titleBox">
            <span class="title-left"></span>
            <span class="title">信息流</span>
          </div>
          <img class="shop-img" src="../../assets/img/service/2.png" alt />
        </div>
        <div class="shop">
          <div class="titleBox">
            <span class="title-left"></span>
            <span class="title">超级APP</span>
          </div>
          <img class="shop-img" src="../../assets/img/service/3.png" alt />
        </div>
      </div>
    </div>
    <div class="introduce">
      <p class="title">合作客户</p>
      <p class="title-en">COOPERATIVE CLIENT</p>
      <i class="nav"></i>
      <div class="appShopBox">
        <div class="shop">
          <div class="paternerTitleBox">
            <span class="title-left"></span>
            <span class="title">游戏类</span>
            <span class="extraTxt">（ 部分客户，排名不分前后 ）</span>
          </div>
          <img class="game-img" src="../../assets/img/service/4.png" alt />
        </div>
        <div class="shop">
          <div class="paternerTitleBox">
            <span class="title-left"></span>
            <span class="title">应用类</span>
            <span class="extraTxt">（ 部分客户，排名不分前后 ）</span>
          </div>
          <img class="game-img" src="../../assets/img/service/5.png" alt />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Service"
};
</script>

<style scoped lang="scss">
.bg {
  font-family: Noto Sans S Chinese;
  .banner {
    position: relative;
    height: 400px;
    width: 100%;
    background: url("../../assets/img/service/banner.jpg") no-repeat;
    background-size: cover;
    .bannerBox {
      position: absolute;
      height: 130px;
      width: 662px;
      left: 0;

      right: 0;
      top: 0;
      bottom: 0;
      margin: auto;
      .title {
        width: 685px;
        text-align: center;
        display: inline-block;
        font-size: 48px;
        font-weight: 900;
        color: rgba(255, 255, 255, 1);
        line-height: 30px;
        span {
          font-weight: 200;
        }
      }
      .content {
        width: 675px;
        margin-top: 38px;
        font-size: 16px;
        font-weight: 400;
        color: rgba(255, 255, 255, 1);
        line-height: 30px;
        text-align: center;
      }
    }
  }
  .introduce {
    padding-top: 66px;
    height: 852px;
    background-color: #f7f6fd;
    // text-indent: 28px;
    .title {
      font-size: 36px;
      text-align: center;
      font-weight: bold;
      color: rgba(51, 51, 51, 1);
    }
    .title-en {
      // height: 11px;
      text-align: center;
      margin-top: 10px;
      font-size: 14px;
      font-weight: 400;
      color: rgba(153, 153, 153, 1);
    }
    .nav {
      width: 34px;
      height: 5px;
      display: block;
      margin: 14px auto 0px auto;
      text-align: center;
      background: rgba(0, 122, 255, 1);
    }
    .appShopBox {
      width: 973px;
      height: 630px;
      margin: 52px auto 0px auto;
      background: rgba(255, 255, 255, 1);
      .shop {
        .titleBox {
          padding-top: 34px;
          padding-left: 100px;
          .title-left {
            width: 7px;
            height: 7px;
            display: inline-block;
            margin-bottom: 1px;
            background: rgba(199, 199, 199, 1);
          }
          .title {
            font-size: 14px;
            margin-left: 7px;
            font-weight: 400;
            color: rgba(51, 51, 51, 1);
          }
        }
        .paternerTitleBox {
          padding-top: 34px;
          padding-left: 90px;
          .title-left {
            width: 7px;
            height: 7px;
            display: inline-block;
            margin-bottom: 1px;
            background: rgba(199, 199, 199, 1);
          }
          .title {
            font-size: 14px;
            margin-left: 7px;
            font-weight: 400;
            color: rgba(51, 51, 51, 1);
          }
        }

        .shop-img {
          margin-left: 55px;
          margin-top: 10px;
          // border: 1px dashed black;
        }
        .game-img {
          margin-left: 93px;
          margin-top: 10px;
          // border: 1px dashed black;
        }
        .app-img {
          width: 783px;
          height: 139px;
          // border: 1px dashed black;
        }
      }
    }
  }
  .extraTxt {
    font-size: 14px;
    font-family: Noto Sans S Chinese;
    font-weight: 400;
    color: #999999;
  }
}
</style>
